<template>
  <div id="app">
    <!-- <div id="no-mobile-support">
      <h3>{{$t('nomobilesupport')}}</h3>
    </div> -->
    <transition name="el-fade-in" mode="out-in">
      <div class="connection-control" v-if="!connection">
        <i class="el-icon-loading"></i>
        <span>{{ $t("reconnect_server") }}</span>
      </div>
    </transition>

    <router-view />
  </div>
</template>

<script>
import $ from "jquery";
export default {
  name: "App",
  async created() {
    await Promise.all([this.$store.dispatch("getEnums"), this.$store.dispatch("getAccountDeleteReasons")]);
    if (window.location.hostname == "live.holacon.com") {
      let OneSignalScript = document.createElement("script");
      OneSignalScript.setAttribute("src", "https://cdn.onesignal.com/sdks/OneSignalSDK.js");
      document.head.appendChild(OneSignalScript);

      window.OneSignal = window.OneSignal || [];
      var initConfig = {
        appId: "7480c8bb-f726-405e-85e9-910dbd2aed76",
        safari_web_id: "web.onesignal.auto.49809676-9f7f-4916-aef3-fd94958742a1",
        autoResubscribe: true,
        notifyButton: {
          enable: true
        }
      };

      OneSignal.push(function() {
        OneSignal.SERVICE_WORKER_PARAM = { scope: "/push/onesignal/" };
        OneSignal.SERVICE_WORKER_PATH = "push/onesignal/OneSignalSDKWorker.js";
        OneSignal.SERVICE_WORKER_UPDATER_PATH = "push/onesignal/OneSignalSDKUpdaterWorker.js";
        OneSignal.init(initConfig);
        OneSignal.showNativePrompt();
      });
    }

    if (this.$workbox) {
      this.$workbox.addEventListener("waiting", e => {
        this.showUpgradeUI = true;
      });
    }

    var versionKey = "v2.5.2";
    var newVersion = localStorage.getItem(versionKey);
    if (newVersion === null) {
      localStorage.setItem(versionKey, "v2.5.2");
      window.location.reload(true);
    }
  },
  computed: {
    connection() {
      return this.$store.getters.getConnection;
    }
  },
  methods: {
    async accept() {
      this.showUpgradeUI = false;
      await this.$workbox.messageSW({ type: "SKIP_WAITING" });
    }
  }
};
</script>

<style lang="less">
@import url("./assets/style.less");
@import url("https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css");
@import "vue-material/dist/vue-material.min.css";
@import (css) url("https://fonts.googleapis.com/css?family=Roboto:300,300i,400,400i,500,500i,700,700i,900,900i&display=swap&subset=latin-ext");
</style>

<style lang="scss">
@import "~vue-material/dist/theme/engine"; // Import the theme engine

@include md-register-theme(
  "default",
  (
    primary: rgb(3, 101, 140),
    // The primary color of your brand
      accent: rgb(3, 101, 140) // The secondary color of your brand
  )
);

@import "~vue-material/dist/theme/all"; // Apply the theme
</style>



// WEBPACK FOOTER //
// src/App.vue